function CuentaCard({ cuenta, onEliminar }) {
  const categoriaLabel = {
    email: 'Email',
    social: 'Red social',
    banking: 'Banco',
    streaming: 'Streaming',
    cloud_storage: 'Almacenamiento',
    work: 'Trabajo',
    shopping: 'Compras',
    gaming: 'Gaming',
    other: 'Otro'
  }

  const accionLabel = {
    transfer: 'Transferir acceso',
    delete: 'Eliminar cuenta',
    memorialize: "Mantener activa",
    notify_only: 'Solo notificar'
  }

  return (
    <div style={{
      ...estilos.tarjeta,
      borderLeft: cuenta.es_critica ? '4px solid #1a1a2e' : '4px solid transparent'
    }}>
      <div style={estilos.fila}>
        <div>
          <span style={estilos.nombre}>{cuenta.nombre}</span>
          {cuenta.es_critica && (
            <span style={estilos.critica}>Crítica</span>
          )}
        </div>
        <span style={estilos.categoria}>
          {categoriaLabel[cuenta.categoria] || 'Otro'}
        </span>
      </div>

      {cuenta.usuario_hint && (
        <div style={estilos.hint}>
          Usuario: {cuenta.usuario_hint}
        </div>
      )}

      <div style={estilos.accion}>
        {accionLabel[cuenta.accion_post_muerte] || cuenta.accion_post_muerte}
      </div>

      {cuenta.instruccion_heredero && (
        <div style={estilos.instruccion}>
          {cuenta.instruccion_heredero}
        </div>
      )}

      <button
        onClick={() => onEliminar(cuenta.id)}
        style={estilos.btnEliminar}
      >
        Eliminar
      </button>
    </div>
  )
}

const estilos = {
  tarjeta: {
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    padding: '16px 20px',
    marginBottom: '12px',
    border: '1px solid #e0e0e0',
  },
  fila: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '8px',
  },
  nombre: {
    fontSize: '15px',
    fontWeight: '600',
    color: '#1a1a2e',
  },
  critica: {
    fontSize: '11px',
    backgroundColor: '#1a1a2e',
    color: '#ffffff',
    padding: '2px 8px',
    borderRadius: '20px',
    marginLeft: '8px',
    fontWeight: '500',
  },
  categoria: {
    fontSize: '12px',
    color: '#888',
    backgroundColor: '#f5f5f5',
    padding: '2px 10px',
    borderRadius: '20px',
  },
  hint: {
    fontSize: '13px',
    color: '#666',
    marginBottom: '6px',
  },
  accion: {
    fontSize: '12px',
    color: '#1a1a2e',
    fontWeight: '500',
    marginBottom: '4px',
  },
  instruccion: {
    fontSize: '12px',
    color: '#888',
    marginBottom: '8px',
  },
  btnEliminar: {
    fontSize: '12px',
    color: '#dc3545',
    backgroundColor: 'transparent',
    border: '1px solid #dc3545',
    padding: '4px 12px',
    borderRadius: '6px',
    cursor: 'pointer',
    marginTop: '6px',
  },
}

export default CuentaCard